import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Components/cleaning/Header.jsx';
import { useLegalDocument } from '../hooks/useLegalDocument.js';

function formatSnapshot(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString('en-US', {
    dateStyle: 'long',
    timeStyle: 'short'
  });
}

export default function LegalDocumentPage({ docType, pageTitle }) {
  const { content, loading, error, updatedAt, refetch } = useLegalDocument(docType);
  const hasContent = Boolean(content && content.trim().length);
  const formattedTimestamp = formatSnapshot(updatedAt);

  return (
    <div className="legal-page">
      <Header showTotal={false} />
      <main className="page-shell legal-shell">
        <article className="card panel-cream legal-card">
          {(loading || error || !hasContent) && (
            <header className="legal-header">
              <h1>{pageTitle}</h1>
            </header>
          )}

          {loading && (
            <div className="legal-status" role="status">
              Loading the latest {pageTitle}…
            </div>
          )}

          {error && (
            <div className="legal-status legal-status--error" role="alert">
              <p>{error}</p>
              <button type="button" className="legal-refresh-button" onClick={refetch}>
                Try again
              </button>
            </div>
          )}

          {!loading && !error && hasContent && (
            <>
              <div className="legal-content" dangerouslySetInnerHTML={{ __html: content }} />
              {formattedTimestamp && (
                <p className="legal-timestamp">Snapshot updated {formattedTimestamp}</p>
              )}
            </>
          )}

          {!loading && !error && !hasContent && (
            <div className="legal-status" role="status">
              The document is unavailable right now.
              <button type="button" className="legal-refresh-button" onClick={refetch}>
                Refresh
              </button>
            </div>
          )}

          <div className="legal-actions">
            <Link to="/" className="legal-back-link">
              Back to booking
            </Link>
          </div>
        </article>
      </main>
    </div>
  );
}
